import { Button } from '@mui/material'
import { makeStyles } from 'tss-react/mui';
import { TStyledButton } from '../../constants/types';


const useStyles = makeStyles()((theme) => ({
  buttonStyle: {
    // height: '38px',
    maxWidth: '100%',
  }
}))


export default function StyledButton(props: TStyledButton) {
  const { classes } = useStyles();
  const {variant, fullWidth, color, onClick, children, className} = props;
  return (
    <>
      <Button
        {...props}
        className={[classes.buttonStyle, className].join(" ")} 
        variant={variant}
        fullWidth={fullWidth}
        color={color}
        onClick={onClick}
      >
        {children}
      </Button>
    </>
  )
}